import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Question } from '../../screens/survey/client/Question';
import { Introduction } from '../../screens/survey/client/Introduction';
import { PrivacyPolicy } from '../../screens/survey/client/PrivacyPolicy';
import { useResponseStore } from '../../store/responseStore';
import { Congratulation } from '../../screens/survey/client/Congratulation';
import { Services } from '../../screens/survey/client/Services';
import { SocketContext } from '../../contexts/SocketContext';

export const useSurvey = () => {

    const [content, setContent] = useState([]);
    const [step, setStep] = useState(0);
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(true);

    const { socket } = useContext(SocketContext);

    const { setQuestions, setOtherData } = useResponseStore();
    
    const { id } = useParams();

    useEffect(() => {
        let subscribed = true;

        subscribed && getSurvey();

        return () => subscribed = false;
    }, []);

    const getSurvey = useCallback(() => {
        setLoading(true);
        socket.emit('frontend:obtener-encuesta', { _id: id }, response => {
            const { ok, total, data } = response;

            if(!ok || total <= 0) {
                setActive(false);
                setLoading(false);
                return;
            }

            const [ survey ] = data;
            setActive(survey?.activo);
           
            setOtherData({
                encuesta: survey?._id,
                codigo_encuesta: survey?.codigo,
                titulo_encuesta: survey?.titulo,
                canal: survey?.canal?.canal,
                sede: survey?.sede?.nombre,
                usuario: survey?.usuario?.nombre || '',
                correo: survey?.area?.correo
            });
    
            setContent(
                [
                    <Introduction data={ survey?.introduccion } action={ changeStep }  />,
                    <Services data={ survey } action={ changeStep } />,
                    ...survey?.preguntas?.map(p => <Question key={ p?.pregunta.toString() } data={ p } action={ (d) => changeStep(d) } />),
                    <PrivacyPolicy action={ changeStep } />,
                    <Congratulation />
                ]
            );
            
            setLoading(false);
        });
    }, []);
            
    const changeStep = (args) => {
        setStep(prev => {
            (prev > 0 && args) && setQuestions(args);
            return prev += 1;
        });
    }

    return {
        content,
        step,
        active,
        loading
    }
}